import React, { useState, useRef, useEffect, useMemo } from "react";
import "./jobs.scss";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "react-bootstrap";
import {
  fetchCandidatesByJobId,
  uploadCsvCandidateFile,
  uploadPdfCandidateFile,
  uploadSingleCandidateResume,
  updateCandidateDetails,
  clearCandidateList,
  exportCandidatesAsCsv,
  bulkUpdateHiringStatus,
  fetchCandidateProfile,
} from "../../Redux/ActionCreators/candidateAction";
import { CANDIDATE_SOURCE } from "../../constants/candidateSource";
import {
  assignedStage,
  fetchJobById,
} from "../../Redux/ActionCreators/jobsAction";
import { Alert, Snackbar } from "@mui/material";
import ApplyStageModal from "../../utils/applyStageModal";
import UploadCandidateModal from "../../utils/UploadCandidateModal";
import ResumeUploadModal from "../../utils/ResumeUploadModal";

const HIRING_STATUS_IDS = {
  Hired: "a7db4d99-448f-4993-be64-e2000d499200",
  "Short Listed": "b4c604a1-7cb6-4e8d-8bd8-b4d7e92a8fbb",
  "On Hold": "a3f100dc-eedf-4965-82c2-84e3025dc35b",
  Rejected: "520f0726-efe2-4f5a-8ad4-81436a979663",
};

const buttonStyleMap = {
  Rejected: { border: "1px solid #FF1C58", background: "#FF1C581A" },
  "On Hold": { border: "1px solid #FFC857", background: "#FFC8571A" },
  "Short Listed": { border: "1px solid #00DDFF", background: "#00DDFF1A" },
  Hired: { border: "1px solid #4CC948", background: "#4CC9481A" },
};

const hiringStatusDotColorMap = {
  Rejected: "#FF1C58",
  "On Hold": "#FFC857",
  "Short Listed": "#00DDFF",
  Hired: "#4CC948",
};

const Candidates = () => {
  const { jobId } = useParams();

  const SESSION_PAGE_SIZE_KEY = useMemo(
    () => `candidates_pageSize_${jobId}`,
    [jobId],
  );
  const SESSION_CURRENT_PAGE_KEY = useMemo(
    () => `candidates_currentPage_${jobId}`,
    [jobId],
  );
  const SESSION_FILTERS_KEY = useMemo(
    () => `candidates_filters_${jobId}`,
    [jobId],
  );
  const SESSION_ACTIVE_TAB_KEY = useMemo(
    () => `candidates_activeTab_${jobId}`,
    [jobId],
  );
  const SESSION_SEARCH_TERM_KEY = useMemo(
    () => `candidates_searchTerm_${jobId}`,
    [jobId],
  );
  const SESSION_ACTIVE_FILTERS_KEY = useMemo(
    () => `candidates_activeFilters_${jobId}`,
    [jobId],
  );

  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showOptions, setShowOptions] = useState(null);
  const [searchTerm, setSearchTerm] = useState(() => {
    return sessionStorage.getItem(SESSION_SEARCH_TERM_KEY) || "";
  });
  const [selectedJobs, setSelectedJobs] = useState([]);
  const [file, setFile] = useState({ type: "", data: [] });
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackSeverity, setSnackSeverity] = useState("error");
  const [snackMessage, setSnackMessage] = useState("");
  const [uploading, setUploading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [jobLoading, setJobLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [searchTrigger, setSearchTrigger] = useState("");
  const [statusLoading, setStatusLoading] = useState({});
  const [rowLoading, setRowLoading] = useState({});
  const [initialFilterApplied, setInitialFilterApplied] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({
    current: 0,
    total: 0,
  });
  const [editModal, setEditModal] = useState({ open: false, candidate: null });
  const [assignProgress, setAssignProgress] = useState({
    current: 0,
    total: 0,
  });
  const [activeFilters, setActiveFilters] = useState(() => {
    try {
      return (
        JSON.parse(sessionStorage.getItem(SESSION_ACTIVE_FILTERS_KEY)) || {
          prescreen: false,
          no_stage_assigned: false,
          voice_call: false,
          assessment: false,
          video_call: false,
          shortlisted: false,
          hired: false,
          rejected: false,
          on_hold: false,
          in_progress: false,
        }
      );
    } catch {
      return {
        prescreen: false,
        no_stage_assigned: false,
        voice_call: false,
        assessment: false,
        video_call: false,
        shortlisted: false,
        hired: false,
        rejected: false,
        on_hold: false,
        in_progress: false,
      };
    }
  });

  const [showSortDropdown, setShowSortDropdown] = useState(false);
  const [activeSorts, setActiveSorts] = useState({});
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const filterDropdownRef = useRef(null);

  const initialFilterValues = {
    days_added: { condition: "", value: "" },
    resume_score: { condition: "", value: "" },
    prescreening_score: { condition: "", value: "" },
    telephonic_score: { condition: "", value: "" },
    assessment_score: { condition: "", value: "" },
    video_interview_score: { condition: "", value: "" },
  };

  const [filterValues, setFilterValues] = useState(initialFilterValues);
  const [appliedFilterValues, setAppliedFilterValues] = useState(
    initialFilterValues,
  );

  const handleFilterChange = (field, type, value) => {
    if (type === "value") {
      if (value === "") {
        setFilterValues((prev) => ({
          ...prev,
          [field]: { ...prev[field], value: "" },
        }));
        return;
      }

      const numVal = Number(value);
      if (value !== "" && (isNaN(numVal) || numVal < 0)) return;
    }

    setFilterValues((prev) => ({
      ...prev,
      [field]: { ...prev[field], [type]: value },
    }));
  };

  const handleApplyFilters = () => {
    setAppliedFilterValues(filterValues);
    setShowFilterDropdown(false);
  };

  const sortRows = [
    { label: "Created At", field: "created_at" },
    // { label: "Score", field: "score" },
    // { label: "Hiring Stage Score", field: "hiring_stage_score" },
    { label: "Resume Score", field: "resume_score" },
    { label: "Pre Screening Score", field: "prescreening_score" },
  ];
  const handleSortToggle = (index, direction) => {
    setActiveSorts((prev) => {
      const currentDir = prev[index];
      if (currentDir === direction) {
        return {};
      }
      return { [index]: direction };
    });
  };

  const safeGet = (k, fallback) => {
    try {
      const v = Number(window?.sessionStorage?.getItem(k));
      return Number.isFinite(v) && v > 0 ? v : fallback;
    } catch {
      return fallback;
    }
  };
  const [pageSize, setPageSize] = useState(() =>
    safeGet(SESSION_PAGE_SIZE_KEY, 10),
  );
  const [currentPage, setCurrentPage] = useState(() =>
    safeGet(SESSION_CURRENT_PAGE_KEY, 1),
  );
  const [editForm, setEditForm] = useState({
    name: "",
    email: "",
    phone_number: "",
  });
  const [resumeModal, setResumeModal] = useState({
    open: false,
    candidateId: null,
  });
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const csvInputRef = useRef(null);
  const pdfInputRef = useRef(null);
  const resumeInputRef = useRef(null);
  const searchDebounceTimer = useRef(null);
  const dropdownRef = useRef(null);
  const sortDropdownRef = useRef(null);
  const dispatch = useDispatch();
  const jobsPerPage = 10;

  const latestJob = useSelector((state) => state.jobs.latestJob);

  const location = useLocation();

  const tabNameMap = {
    voice: "Voice interview",
    assessment: "Assessments",
    video: "Video Interview",
  };

  const searchParams = new URLSearchParams(location.search);
  const tabSlug = location.state?.fromTab || searchParams.get("tab") || "";
  const initialTab = tabNameMap[tabSlug] || "All candidates";
  const [activeTab, setActiveTab] = useState(() => {
    return sessionStorage.getItem(SESSION_ACTIVE_TAB_KEY) || initialTab;
  });

  const isMobile = window.innerWidth < 767;

  const [filters, setFilters] = useState(() => {
    try {
      return (
        JSON.parse(sessionStorage.getItem(SESSION_FILTERS_KEY)) || {
          assignedStage: "",
          averageScore: "",
          addedPeriod: "",
        }
      );
    } catch {
      return { assignedStage: "", averageScore: "", addedPeriod: "" };
    }
  });

  const candidateList = useSelector(
    (state) => state.candidates.candidateList || [],
  );
  const stagesMap = useSelector((state) => state.jobs.stagesMap);

  useEffect(() => {
    sessionStorage.setItem(SESSION_PAGE_SIZE_KEY, pageSize);
  }, [pageSize]);

  useEffect(() => {
    sessionStorage.setItem(SESSION_CURRENT_PAGE_KEY, currentPage);
  }, [currentPage]);

  useEffect(() => {
    sessionStorage.setItem(SESSION_FILTERS_KEY, JSON.stringify(filters));
  }, [filters]);

  useEffect(() => {
    sessionStorage.setItem(SESSION_ACTIVE_TAB_KEY, activeTab);
  }, [activeTab]);

  useEffect(() => {
    sessionStorage.setItem(SESSION_SEARCH_TERM_KEY, searchTerm);
  }, [searchTerm]);

  useEffect(() => {
    sessionStorage.setItem(
      SESSION_ACTIVE_FILTERS_KEY,
      JSON.stringify(activeFilters),
    );
  }, [activeFilters]);

  useEffect(() => {
    if (!initialFilterApplied) return;
    fetchData();
  }, [
    dispatch,
    jobId,
    activeTab,
    filters,
    searchTrigger,
    currentPage,
    pageSize,
    activeFilters,

    appliedFilterValues,
    initialFilterApplied,
  ]);

  useEffect(() => {
    if (location.state?.activateFilter && !initialFilterApplied) {
      const filterKey = location.state.activateFilter;
      setActiveFilters((prev) => {
        const reset = Object.keys(prev).reduce(
          (acc, k) => ({ ...acc, [k]: false }),
          {},
        );
        return { ...reset, [filterKey]: true };
      });
      setInitialFilterApplied(true);
    } else if (!location.state?.activateFilter) {
      setInitialFilterApplied(true);
    }
  }, [location.state, initialFilterApplied]);

  const fetchData = async () => {
    if (!jobId) return;

    dispatch(clearCandidateList());

    const today = new Date().toISOString().split("T")[0];
    let fromDate = "";
    if (filters.addedPeriod) {
      const from = new Date();
      from.setDate(from.getDate() - parseInt(filters.addedPeriod));
      fromDate = from.toISOString().split("T")[0];
    }

    const params = new URLSearchParams({
      page: currentPage,
      page_size: pageSize,
    });

    // Tab-based status ID
    if (activeTab === "Voice interview") {
      params.append("hiring_stage_id", "fd40e3d2-38a9-4cef-937a-93ef6a42d045");
    } else if (activeTab === "Assessments") {
      params.append("hiring_stage_id", "293e9b95-4610-48f2-ae93-c7264cae7d6a");
    } else if (activeTab === "Video Interview") {
      params.append("hiring_stage_id", "ed658e02-1549-4d9e-a735-1f1c1e385f46");
    }

    // Apply date filter
    if (fromDate && today) {
      params.append("from_date", fromDate);
      params.append("to_date", today);
    }

    // Apply search only when 3/6/9... chars typed or cleared
    if (searchTrigger.length > 0) {
      params.append("search", searchTrigger);
    }

    Object.entries(activeFilters).forEach(([key, value]) => {
      if (value) params.append(key, true);
    });

    // Add sorting only for Tel-Screening, Assessments, Video Intw
    if (
      activeFilters.voice_call ||
      activeFilters.assessment ||
      activeFilters.video_call ||
      activeFilters.prescreen
    ) {
      if (Object.keys(activeSorts).length === 0) {
        params.append("order_by", "score");
        params.append("order_direction", "desc");
      }
    }

    // Apply specific score filters from the dropdown
    Object.entries(appliedFilterValues).forEach(([key, filter]) => {
      if (filter.condition && filter.value !== "") {
        // User requested: Less than -> min, Greater than -> max
        if (filter.condition === "less_than") {
          params.append(`${key}_min`, filter.value);
        } else if (filter.condition === "greater_than") {
          params.append(`${key}_max`, filter.value);
        }
      }
    });

    Object.entries(activeSorts).forEach(([index, direction]) => {
      const field = sortRows[index].field;
      params.append("order_by", field);
      params.append("order_direction", direction);
    });

    setLoading(true);
    await dispatch(fetchCandidatesByJobId(jobId, params.toString()));
    setLoading(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowOptions(null);
      }
      if (
        sortDropdownRef.current &&
        !sortDropdownRef.current.contains(event.target)
      ) {
        setShowSortDropdown(false);
      }
      if (
        filterDropdownRef.current &&
        !filterDropdownRef.current.contains(event.target)
      ) {
        setShowFilterDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const fetchJobDetails = async () => {
    setJobLoading(true);
    await dispatch(fetchJobById(jobId));
    setJobLoading(false);
  };

  useEffect(() => {
    if (!jobId) return;
    if (!latestJob || latestJob.id !== jobId) {
      fetchJobDetails();
    }
  }, [jobId, latestJob, dispatch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      const tooltipTriggerList = [].slice.call(
        document.querySelectorAll('[data-bs-toggle="tooltip"]'),
      );
      tooltipTriggerList.map((el) => new window.bootstrap.Tooltip(el));
    }, 150); // Give DOM time to render

    return () => clearTimeout(timer);
  }, [candidateList, activeTab]);

  const handleSearch = async (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    clearTimeout(searchDebounceTimer.current);

    if (value.length === 0) {
      const today = new Date().toISOString().split("T")[0];
      let fromDate = "";
      if (filters.addedPeriod) {
        const from = new Date();
        from.setDate(from.getDate() - parseInt(filters.addedPeriod));
        fromDate = from.toISOString().split("T")[0];
      }

      const params = new URLSearchParams({
        page: 1,
        page_size: jobsPerPage,
      });

      if (activeTab === "Voice interview") {
        params.append(
          "hiring_stage_id",
          "fd40e3d2-38a9-4cef-937a-93ef6a42d045",
        );
      } else if (activeTab === "Assessments") {
        params.append(
          "hiring_stage_id",
          "293e9b95-4610-48f2-ae93-c7264cae7d6a",
        );
      } else if (activeTab === "Video Interview") {
        params.append(
          "hiring_stage_id",
          "ed658e02-1549-4d9e-a735-1f1c1e385f46",
        );
      }

      if (fromDate && today) {
        params.append("from_date", fromDate);
        params.append("to_date", today);
      }

      Object.entries(activeFilters).forEach(([key, value]) => {
        if (value) params.append(key, true);
      });

      dispatch(clearCandidateList());
      setLoading(true);
      await dispatch(fetchCandidatesByJobId(jobId, params.toString()));
      setLoading(false);
      setCurrentPage(1);
      return;
    }

    if (value.length >= 3) {
      searchDebounceTimer.current = setTimeout(() => {
        delaySearch(value);
      }, 700);
    }
  };

  const delaySearch = async (value) => {
    const today = new Date().toISOString().split("T")[0];
    let fromDate = "";
    if (filters.addedPeriod) {
      const from = new Date();
      from.setDate(from.getDate() - parseInt(filters.addedPeriod));
      fromDate = from.toISOString().split("T")[0];
    }

    const params = new URLSearchParams({
      page: 1,
      page_size: jobsPerPage,
      search: value,
    });

    if (activeTab === "Voice interview") {
      params.append("hiring_stage_id", "fd40e3d2-38a9-4cef-937a-93ef6a42d045");
    } else if (activeTab === "Assessments") {
      params.append("hiring_stage_id", "293e9b95-4610-48f2-ae93-c7264cae7d6a");
    } else if (activeTab === "Video Interview") {
      params.append("hiring_stage_id", "ed658e02-1549-4d9e-a735-1f1c1e385f46");
    }

    if (fromDate && today) {
      params.append("from_date", fromDate);
      params.append("to_date", today);
    }

    Object.entries(activeFilters).forEach(([key, value]) => {
      if (value) params.append(key, true);
    });

    dispatch(clearCandidateList());
    setLoading(true);
    await dispatch(fetchCandidatesByJobId(jobId, params.toString()));
    setLoading(false);
    setCurrentPage(1);
  };

  // Export handler
  const handleExport = async () => {
    setExportLoading(true);

    const result = await dispatch(exportCandidatesAsCsv(jobId));

    if (result?.success && result.blob instanceof Blob) {
      const url = window.URL.createObjectURL(result.blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Exported_Candidates_${jobId}.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } else {
      showSnack(result?.message || "Failed to export candidates.");
    }

    setExportLoading(false);
  };

  const MAX_FILES = 20;

  const handleCsvClick = () => {
    csvInputRef.current.click();
  };

  const handlePdfClick = () => {
    pdfInputRef.current.click();
  };

  // Upload handler
  const handleCsvUpload = (e) => {
    const f = e.target.files[0];
    if (!f) return;

    const allowedMimeTypes = [
      "text/csv",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

    const allowedExtensions = [".csv", ".xls", ".xlsx"];
    const fileExtension = f.name
      .substring(f.name.lastIndexOf("."))
      .toLowerCase();
    if (
      !allowedMimeTypes.includes(f.type) &&
      !allowedExtensions.includes(fileExtension)
    ) {
      showSnack("Only CSV or Excel files are allowed.", "error");
      e.target.value = null;
      return;
    }

    if (1 > MAX_FILES) {
      showSnack("You can upload a maximum of 20 files.", "error");
      e.target.value = null;
      return;
    }

    if (pdfInputRef.current) {
      pdfInputRef.current.value = null;
    }

    setFile({ type: "csv", data: [f] });
  };

  const handlePdfUpload = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const allowedMimeTypes = [
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];

    const allowedExtensions = [".pdf", ".docx"];

    if (files.length > MAX_FILES) {
      showSnack("You can upload a maximum of 20 files.", "error");
      e.target.value = null;
      return;
    }

    const invalidFile = files.find((file) => {
      const ext = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();

      return (
        !allowedMimeTypes.includes(file.type) &&
        !allowedExtensions.includes(ext)
      );
    });

    if (invalidFile) {
      showSnack("Only PDF or DOCX files are allowed.", "error");
      e.target.value = null;
      return;
    }

    if (csvInputRef.current) {
      csvInputRef.current.value = null;
    }

    setFile({ type: "pdf", data: files });
  };

  const resetUploadModal = () => {
    setShowUploadModal(false);
    setFile({ type: "", data: [] });
    if (csvInputRef.current) csvInputRef.current.value = null;
    if (pdfInputRef.current) pdfInputRef.current.value = null;
  };

  const handleSelectJob = (id) => {
    setSelectedJobs((prev) =>
      prev.includes(id) ? prev.filter((jobId) => jobId !== id) : [...prev, id],
    );
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedJobs(filteredJobs.map((job) => job.id));
    } else {
      setSelectedJobs([]);
    }
  };

  const snackClosed = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackOpen(false);
  };
  const showSnack = (message, severity = "error") => {
    setSnackMessage(message);
    setSnackSeverity(severity);
    setSnackOpen(true);
  };

  const parseDate = (dateString) => {
    if (typeof dateString !== "string") return new Date(NaN);

    const months = {
      jan: 0,
      feb: 1,
      mar: 2,
      apr: 3,
      may: 4,
      jun: 5,
      jul: 6,
      aug: 7,
      sep: 8,
      oct: 9,
      nov: 10,
      dec: 11,
    };

    const [month, day, year] = dateString.toLowerCase().split(/[\s,]+/);

    return new Date(year, months[month], day);
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  }

  const getCurrentData = () => {
    return candidateList.map((candidate) => ({
      id: candidate.id,
      candidates: candidate.name || "--",
      addedOn: candidate.created_at ? formatDate(candidate.created_at) : "--",
      resumeScore:
        candidate.match_score !== null && candidate.match_score !== undefined
          ? candidate.match_score
          : "--",
      qualifyScore:
        candidate.qualify_score !== null &&
          candidate.qualify_score !== undefined
          ? candidate.qualify_score
          : "N/A",
      assignedStage: candidate.current_job_hiring_stage_id
        ? "Assigned"
        : "Not Assigned",
      stage: candidate.stage,
      stageStatus:
        candidate?.hiring_stage?.status?.name ||
        candidate?.status?.name ||
        "--",
      hiring_stage_score: candidate.hiring_stage_score,
      job_id: candidate?.job_id,
      phone_number: candidate?.phone_number,
    }));
  };

  const handleCandidateUpload = async () => {
    if (!file.data || file.data.length === 0) {
      showSnack("Please upload candidate file(s).");
      return;
    }

    setUploading(true);
    const totalFiles = file.data.length;
    setUploadProgress({ current: 0, total: totalFiles });
    // let result;

    try {
      if (file.type === "pdf") {
        for (let i = 0; i < totalFiles; i++) {
          setUploadProgress({ current: i + 1, total: totalFiles });
          const singleFileArray = [file.data[i]];
          const result = await dispatch(
            uploadPdfCandidateFile(jobId, singleFileArray, undefined, CANDIDATE_SOURCE.RESUME_UPLOAD),
          );

          if (!result?.success) {
            showSnack(`Failed at file ${i + 1}: ${result.message}`, "error");
            break;
          }
        }

        showSnack("PDF files uploaded successfully", "success");
      } else if (file.type === "csv") {
        setUploadProgress({ current: 1, total: 1 });
        const result = await dispatch(
          uploadCsvCandidateFile(jobId, file.data[0]),
        );
        if (result?.success) {
          showSnack(result.message, "success");
        } else {
          showSnack(result.message || "CSV upload failed", "error");
        }
      } else {
        showSnack("Only CSV and PDF files are supported.");
        return;
      }

      setShowUploadModal(false);
      setFile({ type: "", data: [] });
      await dispatch(fetchCandidatesByJobId(jobId));
    } catch (err) {
      showSnack(err?.message || "Unexpected error occurred", "error");
    } finally {
      setUploading(false);
      setUploadProgress({ current: 0, total: 0 });
    }
  };

  const filteredJobs = getCurrentData().filter((job) => {
    if (filters.assignedStage && job.assignedStage !== filters.assignedStage)
      return false;
    if (
      filters.averageScore &&
      parseFloat(job.stageScore) < parseFloat(filters.averageScore)
    )
      return false;
    if (filters.addedPeriod) {
      const jobDate = parseDate(job.addedOn);
      if (isNaN(jobDate.getTime())) return false;
      const currentDate = new Date();
      const diffTime = currentDate - jobDate;
      const diffDays = diffTime / (1000 * 60 * 60 * 24);
      if (diffDays > parseInt(filters.addedPeriod, 10) || diffDays < 0) {
        return false;
      }
    }
    return (
      job.candidates?.includes(searchTerm) || job.addedOn?.includes(searchTerm)
    );
  });

  const downloadSampleCsv = () => {
    const headers = ["name", "email", "phonenumber"];
    const csvContent = [headers].map((r) => r.join(",")).join("\n");
    // use data URI
    const dataUri =
      "data:text/csv;charset=utf-8," + encodeURIComponent(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", dataUri);
    link.setAttribute("download", "sample.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const currentJobs = getCurrentData();

  const pagination = useSelector((state) => state.candidates.pagination || {});
  const totalPages = Math.ceil(pagination.total / pageSize);

  const renderCustomPagination = (totalPages, currentPage, setCurrentPage) => {
    const pagination = [];

    // Previous button
    pagination.push(
      <button
        className="prev-btn"
        key="prev"
        onClick={() => setCurrentPage(currentPage - 1)}
        disabled={currentPage === 1 || isDisabled}
      >
        <img src="/images/leftarrow-icon.svg" alt="" />
      </button>,
    );

    // Show first page ONLY if close to the start
    if (currentPage <= 3) {
      pagination.push(
        <button
          key={1}
          className={currentPage === 1 ? "active" : ""}
          onClick={() => setCurrentPage(1)}
          disabled={isDisabled}
        >
          {1}
        </button>,
      );
    } else {
      pagination.push(<button key="left-dots">...</button>);
    }

    // Middle numbers (currentPage - 1, currentPage, currentPage + 1)
    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);

    for (let i = start; i <= end; i++) {
      pagination.push(
        <button
          key={i}
          className={currentPage === i ? "active" : ""}
          onClick={() => setCurrentPage(i)}
          disabled={isDisabled}
        >
          {i}
        </button>,
      );
    }

    // Show last page ONLY if close to the end
    if (currentPage >= totalPages - 2) {
      if (totalPages > 1) {
        pagination.push(
          <button
            key={totalPages}
            className={currentPage === totalPages ? "active" : ""}
            onClick={() => setCurrentPage(totalPages)}
            disabled={isDisabled}
          >
            {totalPages}
          </button>,
        );
      }
    } else {
      pagination.push(<button key="right-dots">...</button>);
    }

    // Next button
    pagination.push(
      <button
        className="next-btn"
        key="next"
        onClick={() => setCurrentPage(currentPage + 1)}
        disabled={currentPage === totalPages || isDisabled}
      >
        <img
          src="/images/leftarrow-icon.svg"
          alt=""
          style={{ rotate: "180deg" }}
        />
      </button>,
    );

    return pagination;
  };

  const openApplyStagemodal = () => {
    if (selectedJobs?.length) {
      setIsOpen(true);
    } else {
      showSnack("Please select candidate from List");
    }
  };

  const selectAssignedStage = async (stageid, videoDateTime, timezone, videoInterviewType) => {
    const total = selectedJobs?.length;
    setAssignProgress({ current: 0, total });

    for (let i = 0; i < total; i++) {
      const isHybrid = videoInterviewType === "hybrid";
      const obj = [
        {
          job_hiring_stage_id: stageid,
          job_candidate_id: selectedJobs[i],
          ...(!isHybrid && {
            schedule_date: new Date().toISOString(),
            expire_at: new Date(videoDateTime).toISOString(),
            valid_till: new Date(videoDateTime).toISOString(),
            current_timezone: timezone,
            schedule_timezone: timezone,
          }),
          ...(videoInterviewType && { video_interview_type: videoInterviewType }),
        },
      ];

      try {
        const status = await dispatch(
          assignedStage(currentJobs[0]?.job_id, obj),
        );
        if (status !== 200) {
          showSnack(`Failed to assign stage for candidate ${i + 1}`);
        }
      } catch (error) {
        showSnack(`Error assigning stage to candidate ${i + 1}`);
      }

      setAssignProgress((prev) => ({
        ...prev,
        current: i + 1,
      }));
    }

    await dispatch(fetchCandidatesByJobId(currentJobs[0]?.job_id));
    setSelectedJobs([]);
    setIsOpen(false);
    setAssignProgress({ current: 0, total: 0 });
    showSnack("All candidates assigned stage successfully", "success");
  };

  const getAssignStageStyle = (stageName) => {
    return stagesMap.filter((el) => el.name === stageName)[0];
  };

  const getDaysFromToday = (dateString) => {
    if (!dateString) return null;
    const targetDate = new Date(dateString);
    const today = new Date();

    // Reset time parts for accuracy
    targetDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    const diffTime = targetDate - today;
    const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return "Today";
    if (diffDays > 0) return `${diffDays} days from now`;
    return `${Math.abs(diffDays)} days`;
  };

  const getStageIconUrl = (stageName, statusName, defaultUrl) => {
    if (statusName === "Failed" || statusName === "Expired") {
      switch (stageName) {
        case "Voice Call":
          return "/images/circle-phone-red.svg";
        case "Assessment":
          return "/images/person-check-red.svg";
        case "Video Call":
          return "/images/play-video-red.svg";
        default:
          return defaultUrl;
      }
    }
    return defaultUrl;
  };

  const renderAssignedStages = (candidateList, jobId, getAssignStageStyle) => {
    const candidate = candidateList.find((c) => c.id === jobId);
    if (!candidate || !candidate.hiring_stages)
      return <span>Not Assigned</span>;

    // Unique stages (Voice Call, Assessment, Video Call)
    const filteredStages = ["Voice Call", "Assessment", "Video Call"]
      .map((stageName) => {
        const stagesOfType = candidate.hiring_stages.filter(
          (s) => (s.hiring_stage?.name || s.stage?.name) === stageName,
        );
        if (stagesOfType.length === 0) return null;

        // Pick the most recent one based on created_at
        return stagesOfType.reduce((latest, curr) => {
          const latestTime = new Date(latest.created_at).getTime();
          const currTime = new Date(curr.created_at).getTime();
          return currTime > latestTime ? curr : latest;
        });
      })
      .filter(Boolean);

    if (filteredStages.length === 0) return <span>Not Assigned</span>;

    // Render UI (icon + score + divider)
    return filteredStages.map((stageObj, index) => {
      const stage = stageObj.hiring_stage;
      const score = stageObj.score;
      const style = getAssignStageStyle(stage?.name) || {};

      return (
        <div
          key={index}
          style={{
            padding: "2px 8px",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            borderRight:
              index !== filteredStages.length - 1
                ? "1px solid #E4E9F0"
                : "none",
          }}
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title={`${stage.name} - ${stageObj.status?.name}${stageObj.status?.name === "Completed" && score
            ? ` (${score.toFixed(0)}%)`
            : ""
            }`}
        >
          {style.url && (
            <img
              src={getStageIconUrl(
                stage?.name,
                stageObj?.status?.name,
                style.url,
              )}
              alt={stage.name}
              width={16}
              height={16}
            />
          )}
          {score !== null && score !== undefined && (
            <span style={{ fontSize: "14px", fontWeight: 400 }}>
              {score.toFixed(0) || 0}%
            </span>
          )}
        </div>
      );
    });
  };

  const handleStatusChange = async (candidateId, statusName) => {
    const statusId = HIRING_STATUS_IDS[statusName];
    if (!statusId) return showSnack("Invalid hiring status");

    // Mark this candidate as loading
    setStatusLoading((prev) => ({ ...prev, [candidateId]: true }));

    const res = await dispatch(
      updateCandidateDetails(jobId, candidateId, {
        hiring_status_id: statusId,
      }),
    );

    if (res?.success) {
      // Fetch updated profile for just this candidate
      await dispatch(fetchCandidateProfile(jobId, candidateId));
      await fetchJobDetails();
      showSnack(
        `Candidate hiring status updated to ${statusName} successfully`,
        "success",
      );
    } else {
      showSnack(`Failed to update status to ${statusName}`);
    }

    // Remove loading state
    setStatusLoading((prev) => {
      const newState = { ...prev };
      delete newState[candidateId];
      return newState;
    });
  };

  const handleBulkStatusChange = async (statusName) => {
    if (!selectedJobs?.length) {
      showSnack("Please select candidate from List");
      return;
    }
    const statusId = HIRING_STATUS_IDS[statusName];
    if (!statusId) {
      showSnack("Invalid status");
      return;
    }

    const payload = {
      candidate_ids: selectedJobs,
      hiring_status_id: statusId,
    };

    setLoading(true);
    fetchJobDetails();
    const res = await dispatch(bulkUpdateHiringStatus(jobId, payload));
    if (res?.success) {
      showSnack(`Updated candidates to ${statusName}`, "success");
      setSelectedJobs([]);
      await dispatch(fetchCandidatesByJobId(jobId));
    } else {
      showSnack(res?.message || `Failed to update ${statusName}`);
    }
    setLoading(false);
  };

  const getPreScreeningValue = (candidateId) => {
    const original = candidateList.find((c) => c.id === candidateId);
    if (!original?.hiring_stages?.length) return "N/A";

    // Get only Pre-Screening records
    const prescreenStages = original.hiring_stages.filter(
      (s) => s.hiring_stage_id === "3dab71cf-c680-4983-a109-1cff0953999b",
    );

    if (!prescreenStages.length) return "N/A";

    // Pick the most recent by created_at
    const latestPrescreen = prescreenStages.reduce((latest, curr) => {
      return new Date(curr.created_at) > new Date(latest.created_at)
        ? curr
        : latest;
    });

    // Show score first, else status
    const score = latestPrescreen.score;
    const status = latestPrescreen.status?.name;

    if (score !== null && score !== undefined) return `${Math.round(score)}%`;
    if (status) return status;

    return "N/A";
  };

  const handleFilterClick = (filterKey) => {
    setActiveFilters((prev) => {
      const resetFilters = Object.keys(prev).reduce((acc, key) => {
        acc[key] = false;
        return acc;
      }, {});
      setCurrentPage(1);
      return { ...resetFilters, [filterKey]: !prev[filterKey] };
    });
  };

  const handlefilterclear = () => {
    setSearchTerm("");
    setActiveFilters({
      prescreen: false,
      no_stage_assigned: false,
      voice_call: false,
      assessment: false,
      video_call: false,
      shortlisted: false,
      hired: false,
      rejected: false,
      on_hold: false,
      in_progress: false,
    });
    setSearchTrigger("");
  };

  const handleUpdateCandidate = async (candidateId, payload) => {
    // mark this row as loading
    setRowLoading((prev) => ({ ...prev, [candidateId]: true }));

    const res = await dispatch(
      updateCandidateDetails(jobId, candidateId, payload),
    );

    if (res?.success) {
      await dispatch(fetchCandidateProfile(jobId, candidateId));
      showSnack("Candidate updated successfully", "success");
    } else {
      showSnack(res?.message || "Failed to update candidate");
    }

    // clear row loader
    setRowLoading((prev) => {
      const newState = { ...prev };
      delete newState[candidateId];
      return newState;
    });

    setEditModal({ open: false, candidate: null });
  };

  const isDisabled = loading || uploading || jobLoading || exportLoading;

  const getMobileStageScores = (candidate) => {
    const getLatestStage = (stageName) => {
      const stages = candidate?.hiring_stages?.filter(
        (s) => (s.hiring_stage?.name || s.stage?.name) === stageName,
      );
      if (!stages?.length) return null;

      return stages.reduce((latest, curr) =>
        new Date(curr.created_at) > new Date(latest.created_at) ? curr : latest,
      );
    };

    return {
      resume:
        candidate?.match_score !== null && candidate?.match_score !== undefined
          ? `${Math.round(candidate.match_score)}%`
          : "NA",

      prescreen: getPreScreeningValue(candidate.id) || "NA",

      telephone: (() => {
        const stage = getLatestStage("Voice Call");
        return stage?.score != null ? `${Math.round(stage.score)}%` : "NA";
      })(),

      assessment: (() => {
        const stage = getLatestStage("Assessment");
        return stage?.score != null ? `${Math.round(stage.score)}%` : "NA";
      })(),

      video: (() => {
        const stage = getLatestStage("Video Call");
        return stage?.score != null ? `${Math.round(stage.score)}%` : "NA";
      })(),
    };
  };

  return (
    <div className="candidates-page">
      <div className="candidate-details">
        {/* Filter and Search Controls */}
        <div className="controls">
          <div className="search-container">
            <div className="search-wrapper">
              <div className="has-search">
                <span className="form-control-feedback">
                  <img src="/images/search.svg" alt="" />
                </span>
                <input
                  type="text"
                  className="search-bar"
                  placeholder="Search for a candidate"
                  value={searchTerm}
                  onChange={handleSearch}
                />
              </div>
              {(Object.values(activeFilters).some(Boolean) || searchTerm) && (
                <button
                  className="clear-btn"
                  onClick={() => handlefilterclear()}
                  disabled={isDisabled}
                >
                  Clear search / filters
                </button>
              )}
            </div>
            {!isMobile && (
              <div className="candidate-filters">
                <div
                  className={`candidate-filter ${activeFilters.prescreen ? "active" : ""}`}
                  onClick={() => handleFilterClick("prescreen")}
                  style={{
                    pointerEvents: isDisabled ? "none" : "auto",
                    opacity: isDisabled ? 0.6 : 1,
                  }}
                >
                  <p>Pre-Screening</p>
                  <span>
                    {jobLoading ? (
                      <div
                        className="loading-overlay"
                        style={{ alignItems: "start", height: "auto" }}
                      >
                        <div
                          className="spinner-border"
                          role="status"
                          style={{ width: "1rem", height: "1rem" }}
                        >
                          <span className="visually-hidden">
                            Loading job...
                          </span>
                        </div>
                      </div>
                    ) : (
                      <>{latestJob?.job_stats?.pre_screen_count || 0}</>
                    )}
                  </span>
                </div>
                <div
                  className={`candidate-filter ${activeFilters.no_stage_assigned ? "active" : ""
                    }`}
                  onClick={() => handleFilterClick("no_stage_assigned")}
                  style={{
                    pointerEvents: isDisabled ? "none" : "auto",
                    opacity: isDisabled ? 0.6 : 1,
                  }}
                >
                  <p>No Stage Assigned</p>
                  <span>
                    {jobLoading ? (
                      <div
                        className="loading-overlay"
                        style={{ alignItems: "start", height: "auto" }}
                      >
                        <div
                          className="spinner-border"
                          role="status"
                          style={{ width: "1rem", height: "1rem" }}
                        >
                          <span className="visually-hidden">
                            Loading job...
                          </span>
                        </div>
                      </div>
                    ) : (
                      <>{latestJob?.job_stats?.no_stage_assigned || 0}</>
                    )}
                  </span>
                </div>
                <div
                  className={`candidate-filter ${activeFilters.voice_call ? "active" : ""
                    }`}
                  onClick={() => handleFilterClick("voice_call")}
                  style={{
                    pointerEvents: isDisabled ? "none" : "auto",
                    opacity: isDisabled ? 0.6 : 1,
                  }}
                >
                  <p>Tel-Screening</p>
                  <span>
                    {jobLoading ? (
                      <div
                        className="loading-overlay"
                        style={{ alignItems: "start", height: "auto" }}
                      >
                        <div
                          className="spinner-border"
                          role="status"
                          style={{ width: "1rem", height: "1rem" }}
                        >
                          <span className="visually-hidden">
                            Loading job...
                          </span>
                        </div>
                      </div>
                    ) : (
                      <>{latestJob?.job_stats?.voice_stage_count || 0}</>
                    )}
                  </span>
                </div>
                <div
                  className={`candidate-filter ${activeFilters.assessment ? "active" : ""
                    }`}
                  onClick={() => handleFilterClick("assessment")}
                  style={{
                    pointerEvents: isDisabled ? "none" : "auto",
                    opacity: isDisabled ? 0.6 : 1,
                  }}
                >
                  <p>Assessments</p>
                  <span>
                    {jobLoading ? (
                      <div
                        className="loading-overlay"
                        style={{ alignItems: "start", height: "auto" }}
                      >
                        <div
                          className="spinner-border"
                          role="status"
                          style={{ width: "1rem", height: "1rem" }}
                        >
                          <span className="visually-hidden">
                            Loading job...
                          </span>
                        </div>
                      </div>
                    ) : (
                      <>{latestJob?.job_stats?.assesment_stage_count || 0}</>
                    )}
                  </span>
                </div>
                <div
                  className={`candidate-filter ${activeFilters.video_call ? "active" : ""
                    }`}
                  onClick={() => handleFilterClick("video_call")}
                  style={{
                    pointerEvents: isDisabled ? "none" : "auto",
                    opacity: isDisabled ? 0.6 : 1,
                  }}
                >
                  <p>Video Intw</p>
                  <span>
                    {jobLoading ? (
                      <div
                        className="loading-overlay"
                        style={{ alignItems: "start", height: "auto" }}
                      >
                        <div
                          className="spinner-border"
                          role="status"
                          style={{ width: "1rem", height: "1rem" }}
                        >
                          <span className="visually-hidden">
                            Loading job...
                          </span>
                        </div>
                      </div>
                    ) : (
                      <> {latestJob?.job_stats?.video_stage_count || 0}</>
                    )}
                  </span>
                </div>
                <div
                  className={`candidate-filter ${activeFilters.shortlisted ? "active" : ""
                    }`}
                  onClick={() => handleFilterClick("shortlisted")}
                  style={{
                    pointerEvents: isDisabled ? "none" : "auto",
                    opacity: isDisabled ? 0.6 : 1,
                  }}
                >
                  <p>Shortlisted</p>
                  <span>
                    {jobLoading ? (
                      <div
                        className="loading-overlay"
                        style={{ alignItems: "start", height: "auto" }}
                      >
                        <div
                          className="spinner-border"
                          role="status"
                          style={{ width: "1rem", height: "1rem" }}
                        >
                          <span className="visually-hidden">
                            Loading job...
                          </span>
                        </div>
                      </div>
                    ) : (
                      <>{latestJob?.job_stats?.shortlisted_count || 0}</>
                    )}
                  </span>
                </div>
                <div
                  className={`candidate-filter ${activeFilters.hired ? "active" : ""
                    }`}
                  onClick={() => handleFilterClick("hired")}
                  style={{
                    pointerEvents: isDisabled ? "none" : "auto",
                    opacity: isDisabled ? 0.6 : 1,
                  }}
                >
                  <p>Hired</p>
                  <span>
                    {jobLoading ? (
                      <div
                        className="loading-overlay"
                        style={{ alignItems: "start", height: "auto" }}
                      >
                        <div
                          className="spinner-border"
                          role="status"
                          style={{ width: "1rem", height: "1rem" }}
                        >
                          <span className="visually-hidden">
                            Loading job...
                          </span>
                        </div>
                      </div>
                    ) : (
                      <>{latestJob?.job_stats?.hired_count || 0}</>
                    )}
                  </span>
                </div>
                <div
                  className={`candidate-filter ${activeFilters.rejected ? "active" : ""
                    }`}
                  onClick={() => handleFilterClick("rejected")}
                  style={{
                    pointerEvents: isDisabled ? "none" : "auto",
                    opacity: isDisabled ? 0.6 : 1,
                  }}
                >
                  <p>Rejected</p>
                  <span>
                    {jobLoading ? (
                      <div
                        className="loading-overlay"
                        style={{ alignItems: "start", height: "auto" }}
                      >
                        <div
                          className="spinner-border"
                          role="status"
                          style={{ width: "1rem", height: "1rem" }}
                        >
                          <span className="visually-hidden">
                            Loading job...
                          </span>
                        </div>
                      </div>
                    ) : (
                      <>{latestJob?.job_stats?.rejected_count || 0}</>
                    )}
                  </span>
                </div>
                <div
                  className={`candidate-filter ${activeFilters.on_hold ? "active" : ""
                    }`}
                  onClick={() => handleFilterClick("on_hold")}
                  style={{
                    pointerEvents: isDisabled ? "none" : "auto",
                    opacity: isDisabled ? 0.6 : 1,
                  }}
                >
                  <p>On hold</p>
                  <span>
                    {jobLoading ? (
                      <div
                        className="loading-overlay"
                        style={{ alignItems: "start", height: "auto" }}
                      >
                        <div
                          className="spinner-border"
                          role="status"
                          style={{ width: "1rem", height: "1rem" }}
                        >
                          <span className="visually-hidden">
                            Loading job...
                          </span>
                        </div>
                      </div>
                    ) : (
                      <>{latestJob?.job_stats?.on_hold_count || 0}</>
                    )}
                  </span>
                </div>
                <div
                  className={`candidate-filter ${activeFilters.in_progress ? "active" : ""
                    }`}
                  onClick={() => handleFilterClick("in_progress")}
                  style={{
                    pointerEvents: isDisabled ? "none" : "auto",
                    opacity: isDisabled ? 0.6 : 1,
                  }}
                >
                  <p>In Progress</p>
                  <span>
                    {jobLoading ? (
                      <div
                        className="loading-overlay"
                        style={{ alignItems: "start", height: "auto" }}
                      >
                        <div
                          className="spinner-border"
                          role="status"
                          style={{ width: "1rem", height: "1rem" }}
                        >
                          <span className="visually-hidden">
                            Loading job...
                          </span>
                        </div>
                      </div>
                    ) : (
                      <>{latestJob?.job_stats?.in_progress_count || 0}</>
                    )}
                  </span>
                </div>
              </div>
            )}
          </div>
          {!isMobile && (
            <div className="filter-buttons">
              <div className="d-flex flex-wrap" style={{ gap: "8px" }}>
                <button
                  className="apply-assigned-btn"
                  onClick={openApplyStagemodal}
                  disabled={isDisabled}
                >
                  Assign Stage&nbsp;&nbsp;
                  <img
                    src="/images/arrow-down.svg"
                    alt=""
                    width={10}
                    height={10}
                  />
                </button>
                <button
                  className="apply-assigned-btn"
                  onClick={() => handleBulkStatusChange("Rejected")}
                  disabled={isDisabled}
                >
                  <img
                    src="/images/cross-black.svg"
                    alt=""
                    width={10}
                    height={10}
                  />
                  &nbsp;&nbsp;Reject
                </button>
                <button
                  className="apply-assigned-btn"
                  onClick={() => handleBulkStatusChange("On Hold")}
                  disabled={isDisabled}
                >
                  <img
                    src="/images/pause-black.svg"
                    alt=""
                    width={10}
                    height={10}
                  />
                  &nbsp;&nbsp;Put on hold
                </button>
                <button
                  className="apply-assigned-btn"
                  onClick={() => handleBulkStatusChange("Short Listed")}
                  disabled={isDisabled}
                >
                  <img
                    src="/images/tick-black.svg"
                    alt=""
                    width={10}
                    height={10}
                  />
                  &nbsp;&nbsp;Shortlist
                </button>
                <button
                  className="apply-assigned-btn"
                  onClick={() => handleBulkStatusChange("Hired")}
                  disabled={isDisabled}
                >
                  <img
                    src="/images/hired-black.svg"
                    alt=""
                    width={14}
                    height={14}
                  />
                  &nbsp;&nbsp;Mark as hired
                </button>
              </div>
              <div className="d-flex flex-wrap" style={{ gap: "6px" }}>
                <div style={{ position: "relative" }} ref={sortDropdownRef}>
                  <button
                    className="refresh-btn"
                    onClick={() => setShowSortDropdown(!showSortDropdown)}
                    disabled={isDisabled}
                    style={{ width: "80px", height: "32px", display: 'flex', justifyContent: 'space-between', padding: '0 8px' }}
                  >
                    Sort
                    <img
                      src="/images/arrow-down.svg"
                      alt="Sort"
                      style={{
                        width: "16px",
                        height: "16px",
                        filter: showSortDropdown
                          ? "brightness(0) saturate(100%) invert(46%) sepia(55%) saturate(2250%) hue-rotate(313deg) brightness(98%) contrast(96%)"
                          : "none",
                      }}
                    />
                  </button>
                  {showSortDropdown && (
                    <div className="sort-dropdown">
                      <div className="sort-header">
                        <span>Asc</span>
                        <span>Desc</span>
                      </div>
                      {sortRows.map((row, index) => (
                        <div className="sort-row" key={index}>
                          <span>{row.label}</span>
                          <div className="sort-actions">
                            <button
                              className={`sort-arrow-btn ${activeSorts[index] === "asc" ? "active" : ""}`}
                              onClick={() => handleSortToggle(index, "asc")}
                            >
                              <img
                                src="/images/arrow-up.svg"
                                alt=""
                                style={{
                                  filter:
                                    activeSorts[index] === "asc"
                                      ? "brightness(0) invert(1)"
                                      : "none",
                                }}
                              />
                            </button>
                            <button
                              className={`sort-arrow-btn ${activeSorts[index] === "desc" ? "active" : ""}`}
                              onClick={() => handleSortToggle(index, "desc")}
                            >
                              <img
                                src="/images/arrow-up.svg"
                                alt=""
                                style={{
                                  transform: "rotate(180deg)",
                                  filter:
                                    activeSorts[index] === "desc"
                                      ? "brightness(0) invert(1)"
                                      : "none",
                                }}
                              />
                            </button>
                          </div>
                        </div>
                      ))}
                      <button
                        className="sort-apply-btn"
                        onClick={() => {
                          if (currentPage === 1) {
                            fetchData();
                          } else {
                            setCurrentPage(1);
                          }
                          setShowSortDropdown(false);
                        }}
                      >
                        Apply
                      </button>
                    </div>
                  )}
                </div>
                <button
                  onClick={fetchData}
                  className="refresh-btn"
                  disabled={isDisabled}
                  title="Refresh"
                >
                  <img src="/images/reset.svg" alt="" />
                </button>
                <button
                  onClick={handleExport}
                  className="refresh-btn"
                  disabled={exportLoading && isDisabled}
                  title="Download"
                >
                  <img
                    src="/images/download.svg"
                    alt=""
                    width={16}
                    height={16}
                  />
                </button>
              </div>
            </div>
          )}
        </div>
        {/* Job Table */}
        <Table responsive className="job-table">
          {!isMobile && (
            <thead>
              <tr>
                <th style={{ paddingRight: "8px" }}>
                  <input type="checkbox" onChange={handleSelectAll} />
                </th>
                <th style={{ paddingLeft: "0", textAlign: "left" }}>Name</th>
                <th>Days Added</th>
                <th>Resume Score</th>
                <th>Pre-Screening Score</th>
                <th>Stages Assigned</th>
                <th>Hiring Status</th>
                <th></th>
              </tr>
            </thead>
          )}
          {loading ? (
            <tr>
              <td colSpan="10">
                <div
                  className="loading-overlay"
                  style={{
                    alignItems: "start",
                    color: "#F75891",
                    height: "auto",
                  }}
                >
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">
                      Loading job summary...
                    </span>
                  </div>
                </div>
              </td>
            </tr>
          ) : (
            !isMobile ? (
              <tbody>
                {candidateList.length > 0 ? (
                  currentJobs.map((job) => {
                    const hiringStatus =
                      candidateList.find((c) => c.id === job.id)?.hiring_status
                        ?.name || "In Progress";
                    return (
                      <tr key={job.id}>
                        <td className={isMobile ? "d-flex align-items-center" : ""}>
                          <input
                            type="checkbox"
                            checked={selectedJobs.includes(job.id)}
                            onChange={() => handleSelectJob(job.id)}
                          />
                        </td>
                        <td
                          style={{
                            paddingLeft: "0",
                            textAlign: "left",
                            fontSize: "14px",
                          }}
                        >
                          {rowLoading[job.id] ? (
                            <div
                              className="spinner-border"
                              role="status"
                              style={{
                                width: "1rem",
                                height: "1rem",
                                color: "#F75891",
                              }}
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          ) : (
                            <div className="d-flex flex-column gap-2">
                              <strong
                                onClick={() => {
                                  const tabSlugMap = {
                                    "Voice interview": "voice",
                                    Assessments: "assessment",
                                    "Video Interview": "video",
                                    "All candidates": "all",
                                  };
                                  const url = `/jobs/${jobId}/candidates/${job.id}?tab=${tabSlugMap[activeTab]}`;
                                  window.open(url, "_blank");
                                }}
                              >
                                {job.candidates}
                              </strong>
                              <div
                                style={{ fontSize: "10px", color: "#8A9199" }}
                              >
                                {job.phone_number}
                              </div>
                            </div>
                          )}
                        </td>
                        <td>
                          <div className="d-flex flex-column gap-2">
                            <div style={{ fontSize: "14px" }}>
                              {getDaysFromToday(job.addedOn)}
                            </div>
                            <div
                              style={{ fontSize: "10px", color: "#8A9199" }}
                            >
                              {job.addedOn}
                            </div>
                          </div>
                        </td>
                        <td style={{ fontSize: "14px" }}>
                          {typeof job.resumeScore === "number"
                            ? `${job.resumeScore}%`
                            : "--"}
                        </td>
                        <td style={{ fontSize: "14px" }}>
                          {getPreScreeningValue(job.id)}
                        </td>
                        <td>
                          <div className="d-flex justify-content-center">
                            {renderAssignedStages(
                              candidateList,
                              job.id,
                              getAssignStageStyle,
                            )}
                          </div>
                        </td>
                        <td style={{ padding: "0" }}>
                          {candidateList.find((c) => c.id === job.id)
                            ?.resume_url ? (
                            <div className="status-btn">
                              {statusLoading[job.id] ? (
                                <div
                                  className="spinner-border"
                                  role="status"
                                  style={{
                                    width: "1rem",
                                    height: "1rem",
                                    color: "#F75891",
                                  }}
                                >
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </div>
                              ) : (
                                [
                                  "Rejected",
                                  "On Hold",
                                  "Short Listed",
                                  "Hired",
                                ].map((statusName) => {
                                  const isActive =
                                    hiringStatus === statusName;
                                  return (
                                    <button
                                      key={statusName}
                                      style={
                                        isActive
                                          ? buttonStyleMap[statusName]
                                          : hiringStatus &&
                                            hiringStatus !== "In Progress"
                                            ? { background: "#E4E9F0" }
                                            : {
                                              background: "#FFFFFF",
                                              border: "1px solid #E4E9F0",
                                            }
                                      }
                                      disabled={isDisabled}
                                      onClick={() =>
                                        handleStatusChange(job.id, statusName)
                                      }
                                      title={statusName}
                                    >
                                      {statusName === "Rejected" && (
                                        <img
                                          src="/images/cross-black.svg"
                                          alt=""
                                          width={14}
                                          height={14}
                                        />
                                      )}
                                      {statusName === "On Hold" && (
                                        <img
                                          src="/images/pause-black.svg"
                                          alt=""
                                          width={14}
                                          height={14}
                                        />
                                      )}
                                      {statusName === "Short Listed" && (
                                        <img
                                          src="/images/check-black.svg"
                                          alt=""
                                          width={14}
                                          height={14}
                                        />
                                      )}
                                      {statusName === "Hired" && (
                                        <img
                                          src="/images/hired-black.svg"
                                          alt=""
                                          width={14}
                                          height={14}
                                        />
                                      )}
                                    </button>
                                  );
                                })
                              )}
                            </div>
                          ) : (
                            <div className="status-btn">
                              <button
                                onClick={() =>
                                  setResumeModal({
                                    open: true,
                                    candidateId: job.id,
                                  })
                                }
                                disabled={isDisabled}
                              >
                                <img
                                  src="/images/download.svg"
                                  alt=""
                                  style={{ rotate: "180deg" }}
                                  width={16}
                                  height={16}
                                />
                              </button>
                            </div>
                          )}
                        </td>
                        <td>
                          <div
                            className="d-flex justify-content-end gap-2"
                            style={{ paddingRight: isMobile ? "20px" : "" }}
                          >
                            {isMobile &&
                              (() => {
                                const statusName = candidateList.find(
                                  (c) => c.id === job.id,
                                )?.hiring_status?.name;

                                if (
                                  !statusName ||
                                  !hiringStatusDotColorMap[statusName]
                                )
                                  return null;

                                return (
                                  <div className="d-flex align-items-center">
                                    <div
                                      style={{
                                        width: "9px",
                                        height: "9px",
                                        borderRadius: "50%",
                                        background:
                                          hiringStatusDotColorMap[statusName],
                                      }}
                                    />
                                    <p style={{ margin: 0 }}>{statusName}</p>
                                  </div>
                                );
                              })()}
                            <img
                              className="cursor-pointer"
                              src="/images/threedots-vertical.png"
                              alt="Edit"
                              width={isMobile ? 20 : 16}
                              height={isMobile ? 20 : 16}
                              onClick={() => {
                                const candidate = candidateList.find(
                                  (c) => c.id === job.id,
                                );
                                setEditModal({ open: true, candidate });
                                setEditForm({
                                  name: candidate?.name || "",
                                  email: candidate?.email || "",
                                  phone_number: candidate?.phone_number || "",
                                });
                              }}
                              style={{ rotate: isMobile ? "90deg" : null }}
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="9">No candidates found</td>
                  </tr>
                )}
              </tbody>
            ) : (
              <tbody>
                {candidateList.length > 0 ? (
                  currentJobs.map((job) => {
                    const hiringStatus =
                      candidateList.find((c) => c.id === job.id)?.hiring_status
                        ?.name || "In Progress";
                    return (
                      <tr key={job.id}>
                        <div
                          className={
                            isMobile ? "d-flex justify-content-between" : ""
                          }
                          style={{ padding: isMobile ? '' : '0px' }}
                        >
                          <td className={isMobile ? "d-flex align-items-center" : ""}>
                            <input
                              type="checkbox"
                              checked={selectedJobs.includes(job.id)}
                              onChange={() => handleSelectJob(job.id)}
                            />
                          </td>
                          <td
                            style={{
                              paddingLeft: "0",
                              textAlign: "left",
                              fontSize: "14px",
                            }}
                          >
                            {rowLoading[job.id] ? (
                              <div
                                className="spinner-border"
                                role="status"
                                style={{
                                  width: "1rem",
                                  height: "1rem",
                                  color: "#F75891",
                                }}
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            ) : (
                              <div className="d-flex flex-column gap-2">
                                <strong
                                  onClick={() => {
                                    const tabSlugMap = {
                                      "Voice interview": "voice",
                                      Assessments: "assessment",
                                      "Video Interview": "video",
                                      "All candidates": "all",
                                    };
                                    const url = `/jobs/${jobId}/candidates/${job.id}?tab=${tabSlugMap[activeTab]}`;
                                    window.open(url, "_blank");
                                  }}
                                >
                                  {job.candidates}
                                </strong>
                                <div
                                  style={{ fontSize: "10px", color: "#8A9199" }}
                                >
                                  {job.phone_number}
                                </div>
                              </div>
                            )}
                          </td>
                          {!isMobile && (
                            <td>
                              <div className="d-flex flex-column gap-2">
                                <div style={{ fontSize: "14px" }}>
                                  {getDaysFromToday(job.addedOn)}
                                </div>
                                <div
                                  style={{ fontSize: "10px", color: "#8A9199" }}
                                >
                                  {job.addedOn}
                                </div>
                              </div>
                            </td>
                          )}
                          {!isMobile && (
                            <td style={{ fontSize: "14px" }}>
                              {typeof job.resumeScore === "number"
                                ? `${job.resumeScore}%`
                                : "--"}
                            </td>
                          )}
                          {!isMobile && (
                            <td style={{ fontSize: "14px" }}>
                              {getPreScreeningValue(job.id)}
                            </td>
                          )}
                          {!isMobile && (
                            <td>
                              <div className="d-flex justify-content-center">
                                {renderAssignedStages(
                                  candidateList,
                                  job.id,
                                  getAssignStageStyle,
                                )}
                              </div>
                            </td>
                          )}
                          {!isMobile && (
                            <td style={{ padding: "0" }}>
                              {candidateList.find((c) => c.id === job.id)
                                ?.resume_url ? (
                                <div className="status-btn">
                                  {statusLoading[job.id] ? (
                                    <div
                                      className="spinner-border"
                                      role="status"
                                      style={{
                                        width: "1rem",
                                        height: "1rem",
                                        color: "#F75891",
                                      }}
                                    >
                                      <span className="visually-hidden">
                                        Loading...
                                      </span>
                                    </div>
                                  ) : (
                                    [
                                      "Rejected",
                                      "On Hold",
                                      "Short Listed",
                                      "Hired",
                                    ].map((statusName) => {
                                      const isActive =
                                        hiringStatus === statusName;
                                      return (
                                        <button
                                          key={statusName}
                                          style={
                                            isActive
                                              ? buttonStyleMap[statusName]
                                              : hiringStatus &&
                                                hiringStatus !== "In Progress"
                                                ? { background: "#E4E9F0" }
                                                : {
                                                  background: "#FFFFFF",
                                                  border: "1px solid #E4E9F0",
                                                }
                                          }
                                          disabled={isDisabled}
                                          onClick={() =>
                                            handleStatusChange(job.id, statusName)
                                          }
                                        >
                                          {statusName === "Rejected" && (
                                            <img
                                              src="/images/cross-black.svg"
                                              alt=""
                                              width={14}
                                              height={14}
                                            />
                                          )}
                                          {statusName === "On Hold" && (
                                            <img
                                              src="/images/pause-black.svg"
                                              alt=""
                                              width={14}
                                              height={14}
                                            />
                                          )}
                                          {statusName === "Short Listed" && (
                                            <img
                                              src="/images/check-black.svg"
                                              alt=""
                                              width={14}
                                              height={14}
                                            />
                                          )}
                                          {statusName === "Hired" && (
                                            <img
                                              src="/images/hired-black.svg"
                                              alt=""
                                              width={14}
                                              height={14}
                                            />
                                          )}
                                        </button>
                                      );
                                    })
                                  )}
                                </div>
                              ) : (
                                <div className="status-btn">
                                  <button
                                    onClick={() =>
                                      setResumeModal({
                                        open: true,
                                        candidateId: job.id,
                                      })
                                    }
                                    disabled={isDisabled}
                                  >
                                    <img
                                      src="/images/download.svg"
                                      alt=""
                                      style={{ rotate: "180deg" }}
                                      width={16}
                                      height={16}
                                    />
                                  </button>
                                </div>
                              )}
                            </td>
                          )}
                          <td>
                            <div
                              className="d-flex justify-content-end gap-2"
                              style={{ paddingRight: isMobile ? "20px" : "" }}
                            >
                              {isMobile &&
                                (() => {
                                  const statusName = candidateList.find(
                                    (c) => c.id === job.id,
                                  )?.hiring_status?.name;

                                  if (
                                    !statusName ||
                                    !hiringStatusDotColorMap[statusName]
                                  )
                                    return null;

                                  return (
                                    <div className="d-flex align-items-center">
                                      <div
                                        style={{
                                          width: "9px",
                                          height: "9px",
                                          borderRadius: "50%",
                                          background:
                                            hiringStatusDotColorMap[statusName],
                                        }}
                                      />
                                      <p style={{ margin: 0 }}>{statusName}</p>
                                    </div>
                                  );
                                })()}
                              <img
                                className="cursor-pointer"
                                src="/images/threedots-vertical.png"
                                alt="Edit"
                                width={isMobile ? 20 : 16}
                                height={isMobile ? 20 : 16}
                                onClick={() => {
                                  const candidate = candidateList.find(
                                    (c) => c.id === job.id,
                                  );
                                  setEditModal({ open: true, candidate });
                                  setEditForm({
                                    name: candidate?.name || "",
                                    email: candidate?.email || "",
                                    phone_number: candidate?.phone_number || "",
                                  });
                                }}
                                style={{ rotate: isMobile ? "90deg" : null }}
                              />
                            </div>
                          </td>
                        </div>
                        {isMobile && (
                          <div style={{ paddingTop: "8px" }}>
                            {(() => {
                              const candidate = candidateList.find(
                                (c) => c.id === job.id,
                              );
                              if (!candidate) return null;

                              const scores = getMobileStageScores(candidate);

                              return (
                                <div
                                  className="d-flex justify-content-between"
                                  style={{ gap: "5px" }}
                                >
                                  <div className="mobile-label">
                                    <h6>Resume</h6>
                                    <img
                                      src="/images/file-icon-gray.svg"
                                      alt=""
                                      width={16}
                                      height={16}
                                    />
                                    <h5>{scores.resume}</h5>
                                  </div>
                                  <div className="mobile-label">
                                    <h6>Prescreen</h6>
                                    <img
                                      src="/images/user-logout-black.svg"
                                      alt=""
                                      width={16}
                                      height={16}
                                    />
                                    <h5>{scores.prescreen}</h5>
                                  </div>
                                  <div className="mobile-label">
                                    <h6>Telephone</h6>
                                    <img
                                      src="/images/circle-phone-gray.svg"
                                      alt=""
                                      width={16}
                                      height={16}
                                    />
                                    <h5>{scores.telephone}</h5>
                                  </div>
                                  <div className="mobile-label">
                                    <h6>Assessment</h6>
                                    <img
                                      src="/images/user-check-black.svg"
                                      alt=""
                                      width={16}
                                      height={16}
                                    />
                                    <h5>{scores.assessment}</h5>
                                  </div>
                                  <div className="mobile-label">
                                    <h6>Video</h6>
                                    <img
                                      src="/images/file-icon-gray.svg"
                                      alt=""
                                      width={16}
                                      height={16}
                                    />
                                    <h5>{scores.video}</h5>
                                  </div>
                                </div>
                              );
                            })()}
                          </div>
                        )}
                        {isMobile && (
                          <div style={{ paddingTop: "8px" }}>
                            {(() => {
                              return (
                                <div
                                  className="d-flex"
                                  style={{
                                    gap: "5px",
                                    borderBottom: "1px solid #E4E9F0",
                                  }}
                                >
                                  <p
                                    style={{
                                      fontFamily: "inter, sans-serif",
                                      fontWeight: 400,
                                      fontSize: "10px",
                                      lineHeight: "14px",
                                      color: "#525B66",
                                      paddingBottom: "15px",
                                    }}
                                  >
                                    {getDaysFromToday(job.addedOn)}&nbsp;
                                    {job.addedOn}
                                  </p>
                                </div>
                              );
                            })()}
                          </div>
                        )}
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="9">No candidates found</td>
                  </tr>
                )}
              </tbody>
            )
          )}
        </Table>
        {/* Pagination */}
        {!loading && (
          <div className="pagination d-flex" style={{ height: "unset" }}>
            <div
              className="d-flex flex-wrap"
              style={{ gap: !isMobile ? "40px" : "10px", padding: "10px 0" }}
            >
              <div className="d-flex flex-wrap" style={{ gap: "20px" }}>
                <div className="pagination-info d-flex align-items-center">
                  {pagination.total ? (
                    <span style={{ color: "#525B66" }}>
                      Showing {(pagination.page - 1) * pagination.page_size + 1}
                      -
                      {Math.min(
                        pagination.page * pagination.page_size,
                        pagination.total,
                      )}{" "}
                      of <br />
                      <strong>{pagination.total}</strong> Candidates
                    </span>
                  ) : (
                    <span>Showing 0-0 of 0</span>
                  )}
                </div>
                <div className="pagination-buttons">
                  {renderCustomPagination(
                    totalPages,
                    currentPage,
                    setCurrentPage,
                  )}
                </div>
              </div>
              <div className="d-flex align-items-center">
                <span style={{ color: "#525B66", lineHeight: "100%" }}>
                  Candidates <br />
                  per page
                </span>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <select
                  value={pageSize}
                  onChange={(e) => {
                    setPageSize(parseInt(e.target.value));
                    setCurrentPage(1);
                    sessionStorage.setItem(SESSION_CURRENT_PAGE_KEY, 1);
                  }}
                  style={{
                    width: "46px",
                    height: "32px",
                    borderRadius: "2px",
                    border: "1px solid #8A9199",
                    color: "#8A9199",
                  }}
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div>
            </div>
            {!isMobile && (
              <div
                className="d-flex flex-wrap"
                style={{ gap: "16px", padding: "10px 0" }}
              >
                <div className="stage-div">
                  <div
                    className="stage-icon"
                    style={{
                      border: "1px solid #FF1C58",
                      background: "#FF1C581A",
                    }}
                  >
                    <img
                      src="/images/cross-black.svg"
                      alt=""
                      width={12}
                      height={12}
                    />
                  </div>
                  <p>Rejected</p>
                </div>
                <div className="stage-div">
                  <div
                    className="stage-icon"
                    style={{
                      border: "1px solid #FFC857",
                      background: "#FFC8571A",
                    }}
                  >
                    <img
                      src="/images/pause-black.svg"
                      alt=""
                      width={12}
                      height={12}
                    />
                  </div>
                  <p>On hold</p>
                </div>
                <div className="stage-div">
                  <div
                    className="stage-icon"
                    style={{
                      border: "1px solid #00DDFF",
                      background: "#00DDFF1A",
                    }}
                  >
                    <img
                      src="/images/check-black.svg"
                      alt=""
                      width={12}
                      height={12}
                    />
                  </div>
                  <p>Shortlisted</p>
                </div>
                <div className="stage-div">
                  <div
                    className="stage-icon"
                    style={{
                      border: "1px solid #4CC948",
                      background: "#4CC9481A",
                    }}
                  >
                    <img
                      src="/images/hired-black.svg"
                      alt=""
                      width={12}
                      height={12}
                    />
                  </div>
                  <p>Hired</p>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      {
        showUploadModal === true ? (
          <UploadCandidateModal
            show={showUploadModal}
            uploading={uploading}
            file={file}
            uploadProgress={uploadProgress}
            csvInputRef={csvInputRef}
            pdfInputRef={pdfInputRef}
            handleCsvClick={handleCsvClick}
            handlePdfClick={handlePdfClick}
            handleCsvUpload={handleCsvUpload}
            handlePdfUpload={handlePdfUpload}
            handleCandidateUpload={handleCandidateUpload}
            resetUploadModal={resetUploadModal}
            downloadSampleCsv={downloadSampleCsv}
          />
        ) : null
      }
      <ResumeUploadModal
        show={resumeModal.open}
        uploading={uploading}
        file={file}
        resumeInputRef={resumeInputRef}
        onClose={() => setResumeModal({ open: false, candidateId: null })}
        onFileSelect={(e) => {
          const f = e.target.files[0];
          if (
            !f ||
            ![
              "application/pdf",
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            ].includes(f.type)
          ) {
            showSnack("Only PDF and DOCX files are supported.");
            return;
          }
          setFile(f); // ✅ Only allow single resume
        }}
        onUploadClick={async () => {
          if (!file || !file.name) {
            showSnack("Please upload a resume.");
            return;
          }
          setUploading(true);
          const result = await dispatch(
            uploadSingleCandidateResume(jobId, resumeModal.candidateId, file),
          );
          setUploading(false);

          if (result.success) {
            showSnack(result.message, "success");
            setResumeModal({ open: false, candidateId: null });
            setFile(null);
          } else {
            showSnack(result.message);
          }
        }}
      />
      {
        editModal.open && (
          <div className="upload-modal">
            <div
              className="modal-content"
              style={{ width: isMobile ? "auto" : "500px" }}
            >
              <div className="modal-head">
                <div></div>
                <h3>Edit Candidate</h3>
                <img
                  src="/images/close-icon.svg"
                  alt=""
                  onClick={() => setEditModal({ open: false, candidate: null })}
                />
              </div>
              <div
                className="modal-input d-flex flex-column align-items-start"
                style={{
                  gap: "15px",
                  padding: "15px",
                  width: isMobile ? "auto" : "",
                }}
              >
                <div className="modal-input-label">
                  <label>Name :</label>
                  <input
                    type="text"
                    value={editForm.name}
                    onChange={(e) =>
                      setEditForm({ ...editForm, name: e.target.value })
                    }
                  />
                </div>
                <div className="modal-input-label">
                  <label>Email :</label>
                  <input
                    type="email"
                    value={editForm.email}
                    onChange={(e) =>
                      setEditForm({ ...editForm, email: e.target.value })
                    }
                  />
                </div>
                <div className="modal-input-label">
                  <label>Phone Number :</label>
                  <input
                    type="text"
                    value={editForm.phone_number}
                    onChange={(e) =>
                      setEditForm({ ...editForm, phone_number: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="d-flex justify-content-center">
                <button
                  className="upload-btn"
                  onClick={async () => {
                    const res = await dispatch(
                      updateCandidateDetails(
                        jobId,
                        editModal.candidate.id,
                        editForm,
                      ),
                    );
                    if (res?.success) {
                      setEditModal({ open: false, candidate: null });
                      dispatch(fetchCandidatesByJobId(jobId));
                      showSnack("Candidate updated successfully", "success");
                    } else {
                      showSnack("Failed to update candidate");
                    }
                  }}
                  disabled={isDisabled}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        )
      }

      {
        isOpen && (
          <ApplyStageModal
            isOpen={isOpen}
            setIsOpen={() => setIsOpen(false)}
            selectAssignedStage={selectAssignedStage}
            jobId={currentJobs[0]?.job_id}
            loading={loading}
            assignProgress={assignProgress}
          />
        )
      }
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={snackOpen}
        autoHideDuration={3000}
        onClose={snackClosed}
      >
        <Alert
          onClose={snackClosed}
          severity={snackSeverity}
          sx={{ width: "100%" }}
        >
          {snackMessage}
        </Alert>
      </Snackbar>
    </div >
  );
};

export default Candidates;
